export const LABELS_HOME = {
    secaoInicial: {
        plataforma: 'Plataforma',
        nome: 'Docentes do Brasil',
        descricao: 'Indicadores sobre condições de trabalho docente',
    },

    indicadores: {
        titulo: 'Indicadores sobre condições de trabalho docente',
        descricao:
            'Consulte indicadores sobre a realidade dos docentes no Brasil e por rede de ensino - estaduais e municipais.',
        acao: 'Explorar resultados',
    },

    outrasConsultas: {
        titulo: 'Outras consultas',
        cards: {
            mapas: {
                titulo: 'Mapas',
                descricao: 'Explore visualizações geoespaciais de indicadores das condições de trabalho docente',
                altImagem: 'Mapa do Brasil com marcações de localidades',
            },
            graficos: {
                titulo: 'Gráficos',
                descricao: 'Visualize indicadores das condições de trabalho docente em gráficos de duas variáveis',
                altImagem: 'Gráfico de dispersão de duas variáveis',
            },
            basesDados: {
                titulo: 'Bases de dados',
                descricao: 'Baixe as bases de dados dos indicadores das condições de trabalho docente',
                altImagem: 'Planilha de dados com uma lupa',
            },
        },
    },

    comoConstruimos: {
        titulo: 'Como construímos a plataforma',
        descricao:
            'Acesse as fichas técnicas e conheça a definição de cada indicador, critérios de cálculo, periodicidade de ' +
            'atualização, medida e filtros de resultado e demais informações técnicas que subsidiam a construção dos ' +
            'indicadores.',
        acao: 'Acessar fichas técnicas',
        altImagem: 'Imagem como construímos',
    },
} as const;
